import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repository/RepositoryFactory";
import { v4 as uuidv4 } from "uuid";

export const addRestaurantImages =
  (id, imagesArr, onSuccess) => async (dispatch) => {
    dispatch(addLoader(true));

    const userRef = firebase.firestore().collection("users").doc(id);
    const snapshot = await userRef.get();
    const currentImages = snapshot.get("restaurantImages") || [];

    const totalImages = currentImages?.length + imagesArr?.length;
    if (totalImages > 5) {
      dispatch(addLoader(false));
      toast.error(
        "A restaurant can have a maximum of 5 images at a time, please remove the existing images to add new imaegs"
      );
      return;
    }

    let tempArr = [];
    for (let singleFile of imagesArr) {
      let imgURL;
      let customImgKey2 = firebase.firestore().collection("users").doc();
      var imgName = singleFile.image.name;
      let ext3 = imgName.slice(imgName.lastIndexOf("."));
      var imgLets = await firebase
        .storage()
        .ref("restaurant_images/" + customImgKey2.id + ext3.toLowerCase())
        .put(singleFile.image);
      imgURL = await imgLets.ref.getDownloadURL();
      tempArr.push({
        url: imgURL
      });
    }

    for (let singleObj of tempArr) {
      currentImages.push(singleObj.url);
    }

    await userRef
      .set(
        {
          restaurantImages: currentImages
        },
        { merge: true }
      )
      .then(() => {
        dispatch(addLoader(false));
        toast.success("Images Added Successfully");
        onSuccess();
      })
      .catch((err) => {
        alert(err);
        dispatch(addLoader(false));
      });
  };

export const updateRestaurantImage =
  (id, index, image, fileUrlData, onSuccess) => async (dispatch) => {
    dispatch(imageLoader(true));
    let imgURL;

    try {
      if (fileUrlData) {
        await firebase.storage().refFromURL(fileUrlData).delete();
      }
      if (image) {
        let customImgKey2 = firebase.firestore().collection("users").doc();
        const imgName = image.name;
        const ext3 = imgName.slice(imgName.lastIndexOf("."));
        const imgLets = await firebase
          .storage()
          .ref("restaurant_images/" + customImgKey2.id + ext3.toLowerCase())
          .put(image);
        imgURL = await imgLets.ref.getDownloadURL();
      }
      const userRef = firebase.firestore().collection("users").doc(id);
      const userDoc = await userRef.get();
      const restaurantImgArray = userDoc.get("restaurantImages");
      restaurantImgArray[index] = imgURL;

      await userRef.update({ restaurantImages: restaurantImgArray });

      dispatch(imageLoader(false));
      toast.success("Image Updated Successfully");
      onSuccess();
    } catch (err) {
      alert(err.message || err);
      dispatch(imageLoader(false));
    }
  };

export const removeRestaurantImage =
  (id, obj, onSuccess) => async (dispatch) => {
    dispatch(bannerDeleteLoader(true));
    const userRef = firebase.firestore().collection("users").doc(id);
    await userRef
      .update({
        restaurantImages: firebase.firestore.FieldValue.arrayRemove(obj)
      })
      .then(() => {
        firebase.storage().refFromURL(obj).delete();
        dispatch(bannerDeleteLoader(false));
        toast.success("Image Removed Successfully");
        onSuccess();
      })
      .catch((err) => {
        alert(err);
        dispatch(bannerDeleteLoader(false));
      });
  };

// Store Forward Fees Action

export const addForwardFees = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(addForwardFeesLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .set(
      {
        forwardFees: firebase.firestore.FieldValue.arrayUnion(obj)
      },
      { merge: true }
    )
    .then(() => {
      dispatch(addForwardFeesLoader(false));
      toast.success("Forward Fees Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(addForwardFeesLoader(false));
    });
};

export const updateForwardFees = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(updateForwardFeesLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const userDoc = await userRef.get();
  const forwardFeesArray = userDoc.get("forwardFees");

  const index = forwardFeesArray.findIndex(
    (fee) => fee.provider === obj.provider
  );
  if (index !== -1) {
    forwardFeesArray[index] = obj;
    await userRef
      .update({ forwardFees: forwardFeesArray })
      .then(() => {
        onSuccess();
        dispatch(updateForwardFeesLoader(false));
        toast.success("Forward Fees Updated Successfully");
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(updateForwardFeesLoader(false));
      });
  } else {
    dispatch(updateForwardFeesLoader(false));
    toast.error("Provider not found");
  }
};

export const getForwardFees = (restaurantID) => (dispatch) => {
  dispatch(getForwardFeesLoader(true));
  try {
    const userRef = firebase.firestore().collection("users").doc(restaurantID);

    userRef.onSnapshot((snapshot) => {
      const forwardFeesArray = snapshot.data()?.forwardFees;
      dispatch({ type: "GET_FORWARD_FEE", payload: forwardFeesArray });
      dispatch(getForwardFeesLoader(false));
    });
  } catch (error) {
    dispatch(getForwardFeesLoader(false));
    toast.error(error.message);
  }
};

export const deleteForwardFee =
  (obj, restaurantID, onSuccess) => async (dispatch) => {
    try {
      dispatch(deleteForwardFeesLoader(obj?.id));
      const userRef = firebase
        .firestore()
        .collection("users")
        .doc(restaurantID);

      await firebase.firestore().runTransaction(async (transaction) => {
        const doc = await transaction.get(userRef);
        const forwardFeesArray = doc.get("forwardFees");

        const index = forwardFeesArray.findIndex(
          (item) => item.provider === obj.provider
        );

        if (index !== -1) {
          forwardFeesArray.splice(index, 1);
          transaction.update(userRef, { forwardFees: forwardFeesArray });
          toast.success("Forward fee deleted successfully.");
          dispatch(deleteForwardFeesLoader(""));
          if (onSuccess) onSuccess();
        } else {
          toast.error("No matching forward fee found.");
          dispatch(deleteForwardFeesLoader(""));
        }
      });
    } catch (error) {
      console.error("Error deleting forward fee:", error);
      dispatch(deleteForwardFeesLoader(false));
    }
  };

// ===================
// Add Payment Methods

export const addPaymentConnections =
  (id, paymentMethod, onSuccess) => async (dispatch) => {
    dispatch(paymentConnectionLoader(true));
    const userRef = firebase.firestore().collection("users").doc(id);
    const userDoc = await userRef.get();

    let paymentConnections = userDoc.get("paymentConnections") || {};

    const currentStatus = paymentConnections[paymentMethod] || false;
    if (currentStatus === true) {
      return;
    }

    paymentConnections[paymentMethod] = true;

    await userRef
      .set({ paymentConnections }, { merge: true })
      .then(() => {
        dispatch(paymentConnectionLoader(false));
        // toast.success("Payment Method Updated Successfully");
        onSuccess();
      })
      .catch((err) => {
        console.error(err.message);
        dispatch(paymentConnectionLoader(false));
      });
  };

export const addPaymentMethodDetails =
  (id, data, paymentMethod, onSuccess) => async (dispatch) => {
    dispatch(paymentConnectionLoader(true));
    const userRef = firebase.firestore().collection("users").doc(id);
    const userDoc = await userRef.get();

    let methodClientKey = userDoc.get(`${paymentMethod}ClientKey`);
    let methodSecretKey = userDoc.get(`${paymentMethod}SecretKey`);
    const updateData = {};

    if (
      data[`${paymentMethod}ClientKey`] &&
      data[`${paymentMethod}ClientKey`] !== methodClientKey
    ) {
      updateData[`${paymentMethod}ClientKey`] =
        data[`${paymentMethod}ClientKey`];
    }

    if (
      data[`${paymentMethod}SecretKey`] &&
      data[`${paymentMethod}SecretKey`] !== methodSecretKey
    ) {
      updateData[`${paymentMethod}SecretKey`] =
        data[`${paymentMethod}SecretKey`];
    }

    if (Object.keys(updateData).length > 0) {
      await userRef
        .set(updateData, { merge: true })
        .then(() => {
          dispatch({
            type:
              paymentMethod.toLowerCase() === "paypal"
                ? "UPDATE_PAYMENT_METHOD_DETAILS_SUCCESS_PAYPAL"
                : "UPDATE_PAYMENT_METHOD_DETAILS_SUCCESS_STRIPE",
            payload: data
          });

          dispatch(paymentConnectionLoader(false));
          toast.success("Payment Method Details Added Successfully");
          onSuccess();
        })
        .catch((err) => {
          dispatch(paymentConnectionLoader(false));
          console.error(err.message);
        });
    } else {
      dispatch(paymentConnectionLoader(false));
      toast.info("No new payment method details to update.");
      onSuccess();
    }
  };

export const removePaymentMethodDetails =
  (id, paymentMethod, onSuccess) => async (dispatch) => {
    dispatch(removePaymentLoader(true));

    const userQuery = firebase
      .firestore()
      .collection("users")
      .where("restaurantID", "==", id);

    try {
      const querySnapshot = await userQuery.get();

      if (querySnapshot.empty) {
        throw new Error("No user found with the provided restaurantID");
      }

      querySnapshot.forEach(async (doc) => {
        const fieldsToDelete = {
          [`${paymentMethod}ClientKey`]: firebase.firestore.FieldValue.delete(),
          [`${paymentMethod}SecretKey`]: firebase.firestore.FieldValue.delete()
        };

        await doc.ref.update(fieldsToDelete);
        await doc.ref.set(
          {
            paymentConnections: {
              [paymentMethod]: false
            }
          },
          { merge: true }
        );
      });

      dispatch({
        type:
          paymentMethod.toLowerCase() === "paypal"
            ? "REMOVE_PAYMENT_METHOD_DETAILS_SUCCESS_PAYPAL"
            : "REMOVE_PAYMENT_METHOD_DETAILS_SUCCESS_STRIPE",
        payload: paymentMethod
      });

      dispatch(removePaymentLoader(false));
      onSuccess();
      toast.success("Payment Method Details Removed Successfully");
    } catch (err) {
      console.error("Error removing payment method details:", err);
      dispatch(removePaymentLoader(false));
      toast.error("Failed to remove payment method details");
    }
  };

// ===============

// Store Social Profile Actions

export const addSocialProfile = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(Loader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .set(
      {
        socialProfiles: firebase.firestore.FieldValue.arrayUnion(obj)
      },
      { merge: true }
    )
    .then(() => {
      dispatch(Loader(false));
      toast.success("Social Profile Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      alert(err);
      dispatch(Loader(false));
    });
};

export const updateSocialProfile = (id, type, url) => async (dispatch) => {
  dispatch(Loader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const userDoc = await userRef.get();
  const socialProfilesArray = userDoc.get("socialProfiles");
  const matchingProfile = socialProfilesArray.find(
    (profile) => profile.type === type
  );
  if (matchingProfile) {
    matchingProfile.url = url;
    try {
      // Update the Firestore document with the modified socialProfilesArray
      await userRef.update({ socialProfiles: socialProfilesArray });
      dispatch({
        type: "UPDATE_SOCIAL_PROFILE_LINKS",
        payload: { type, url }
      });
      dispatch(Loader(false));
      toast.success("Social Profile Updated Successfully");
    } catch (err) {
      alert(err);
      dispatch(Loader(false));
    }
  } else {
    const errorMessage = "No social profile with the specified type found.";
    alert(errorMessage);
    dispatch(Loader(false));
  }
};

export const fetchAdditionalCharges = (id) => (dispatch) => {
  dispatch(chargesLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const unsubscribe = userRef.onSnapshot(
    (doc) => {
      const data = doc.data();
      const charges = data?.additionalCharges || [];

      dispatch({
        type: "FETCH_ADDITIONAL_CHARGES_SUCCESS",
        payload: charges
      });

      dispatch(chargesLoader(false));
    },
    (err) => {
      toast.error(err.message);
      dispatch(chargesLoader(false));
    }
  );
  return unsubscribe;
};

export const addAdditionalCharges =
  (id, data, onSuccess) => async (dispatch) => {
    const userRef = firebase.firestore().collection("users").doc(id);
    const chargeWithId = { ...data, id: uuidv4() };

    try {
      await userRef.update({
        additionalCharges:
          firebase.firestore.FieldValue.arrayUnion(chargeWithId)
      });
      toast.success("Additional Charges Added Successfully");
      if (onSuccess) onSuccess();
    } catch (err) {
      if (err.code === "not-found") {
        try {
          await userRef.set(
            {
              additionalCharges: [chargeWithId]
            },
            { merge: true }
          );

          dispatch({
            type: "ADD_ADDITIONAL_CHARGE_SUCCESS",
            payload: chargeWithId
          });

          toast.success("Additional Charges Added Successfully");
          if (onSuccess) onSuccess();
        } catch (innerErr) {
          toast.error(innerErr.message);
        }
      } else {
        toast.error(err.message);
      }
    }
  };

export const deleteAdditionalCharge =
  (userId, chargeObj, onSuccess) => async (dispatch) => {
    dispatch(chargesDeleteLoader(true));
    const userRef = firebase.firestore().collection("users").doc(userId);
    try {
      const doc = await userRef.get();
      if (!doc.exists) throw new Error("User not found");
      const data = doc.data();
      if (!data.additionalCharges || !Array.isArray(data.additionalCharges)) {
        throw new Error("No additional charges found");
      }
      const updatedCharges = data.additionalCharges.filter(
        (charge) => charge.id !== chargeObj.id
      );
      await userRef.update({
        additionalCharges: updatedCharges
      });

      toast.success("Charge deleted successfully!");
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err.message);
    } finally {
      dispatch(chargesDeleteLoader(false));
    }
  };

export const updateAdditionalCharge =
  (userId, updatedData, onSuccess) => async (dispatch) => {
    const userRef = firebase.firestore().collection("users").doc(userId);
    try {
      const doc = await userRef.get();
      if (!doc.exists) throw new Error("User not found");
      const data = doc.data();
      const charges = data?.additionalCharges || [];
      const updatedCharges = charges.map((charge) => {
        if (charge.id === updatedData.id) {
          return { ...charge, ...updatedData };
        }
        return charge;
      });
      await userRef.update({ additionalCharges: updatedCharges });
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err.message);
    }
  };

export const addTips = (id, value, onSuccess) => async (dispatch) => {
  dispatch(tipLoader(true));
  try {
    const userRef = firebase.firestore().collection("users").doc(id);
    await userRef.set(
      {
        tipPercentages: firebase.firestore.FieldValue.arrayUnion(value)
      },
      { merge: true }
    );

    const doc = await userRef.get();
    dispatch({
      type: "UPDATE_RESTAURANT_TIP",
      payload: { percentages: doc.data().tipPercentages }
    });

    toast.success("Tip Added Successfully");
    onSuccess();
  } catch (err) {
    toast.error(err.message);
  } finally {
    dispatch(tipLoader(false));
  }
};

export const updateTips = (id, index, value, onSuccess) => async (dispatch) => {
  try {
    dispatch(Loader(true));
    let arr = [];
    arr.push(value);
    const userRef = firebase.firestore().collection("users").doc(id);
    const userDoc = await userRef.get();
    const tipPercentagesArray = userDoc.get("tipPercentages");
    tipPercentagesArray[index] = arr[0];

    await userRef.update({ tipPercentages: tipPercentagesArray });
    dispatch({
      type: "UPDATE_RESTAURANT_TIP",
      payload: { percentages: tipPercentagesArray }
    });
    toast.success("Tip Updated Successfully");
    onSuccess();
  } catch (err) {
    toast.error(err.message || "An unknown error has occured");
    dispatch(Loader(false));
  } finally {
    dispatch(Loader(false));
  }
};

export const removeTip = (id, value, onSuccess) => async (dispatch) => {
  dispatch(removeLoader(true));
  let arr = [];
  arr.push(value);
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .update({
      tipPercentages: firebase.firestore.FieldValue.arrayRemove(arr[0])
    })
    .then(async () => {
      dispatch(removeLoader(false));
      const userRef = firebase.firestore().collection("users").doc(id);
      const Doc = await userRef.get();
      dispatch({
        type: "UPDATE_RESTAURANT_TIP",
        payload: { percentages: Doc.data().tipPercentages }
      });
      toast.success("Tip Removed Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(removeLoader(false));
    });
};

export const addHolidays = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(addHolidayLoading(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .set(
      {
        holidays: firebase.firestore.FieldValue.arrayUnion(obj)
      },
      { merge: true }
    )
    .then(() => {
      dispatch(addHolidayLoading(false));
      toast.success("Holiday Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(addHolidayLoading(false));
    });
};

export const updateHoliday =
  (id, index, updatedObj, onSuccess) => async (dispatch) => {
    dispatch(Loader(true));
    const userRef = firebase.firestore().collection("users").doc(id);
    const userDoc = await userRef.get();
    const holidaysArray = userDoc.get("holidays");
    holidaysArray[index] = updatedObj;
    await userRef
      .update({ holidays: holidaysArray })
      .then(() => {
        dispatch(Loader(false));
        toast.success("Holiday Updated Successfully");
        onSuccess();
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(Loader(false));
      });
  };

export const removeHoliday = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(deleteHolidayLoading(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .update({
      holidays: firebase.firestore.FieldValue.arrayRemove(obj)
    })
    .then(() => {
      dispatch(deleteHolidayLoading(false));
      toast.success("Holiday Removed Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(deleteHolidayLoading(false));
    });
};

export const addStoreTiming = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(Loader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .set(
      {
        storeTiming: firebase.firestore.FieldValue.arrayUnion(obj)
      },
      { merge: true }
    )
    .then(() => {
      dispatch(Loader(false));
      toast.success("Store Timeing Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(Loader(false));
    });
};

export const fetchStoreTimings = (id) => (dispatch) => {
  try {
    const userRef = firebase.firestore().collection("users").doc(id);

    // Subscribe to real-time updates
    const unsubscribe = userRef.onSnapshot(
      (docSnapshot) => {
        if (docSnapshot.exists) {
          let storeTimingArray = docSnapshot.get("storeTiming");

          dispatch({
            type: "FETCH_STORE_TIMINGS",
            payload: storeTimingArray
          });
        }
      },
      (error) => {
        console.error("Error fetching store timings:", error);
      }
    );

    return unsubscribe; // To allow unsubscribing from the snapshot listener
  } catch (error) {
    console.error("Error in fetchStoreTimings:", error);
  }
};

export const updateStoreTiming =
  (id, index, updatedObj, applyAll, onSuccess) => async (dispatch) => {
    dispatch(storeLoader(true));
    const userRef = firebase.firestore().collection("users").doc(id);
    const userDoc = await userRef.get();
    let storeTimingArray = userDoc.get("storeTiming");
    if (applyAll) {
      storeTimingArray = storeTimingArray.map((element) => ({
        ...element,
        startTime: updatedObj?.startTime,
        endTime: updatedObj?.endTime
      }));
    } else {
      storeTimingArray[index] = updatedObj;
    }

    await userRef
      .update({ storeTiming: storeTimingArray })
      .then(() => {
        dispatch({
          type: "UPDATE_STORE_TIMING",
          payload: storeTimingArray
        });
        dispatch(fetchStoreTimings(id));
        toast.success("Store Timing Updated Successfully");
        dispatch(storeLoader(false));
        onSuccess();
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(storeLoader(false));
      });
  };

export const addPickUpDays = (id, days, timeObj) => async (dispatch) => {
  dispatch(pickupLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const pickUpDays = days.map((day) => ({
    day: day,
    endTime: timeObj?.endTime,
    startTime: timeObj?.startTime
  }));
  try {
    await userRef.set(
      {
        pickupDays: pickUpDays
      },
      { merge: true }
    );
    dispatch({ type: "ADD_PICKUP_DAYS", payload: pickUpDays });
    dispatch(pickupLoader(false));
    toast.success("PickUp Days Added Successfully");
  } catch (err) {
    toast.error(err.message);
    dispatch(pickupLoader(false));
  }
};

export const updatePickUpDays = (id, days, timeObj) => async (dispatch) => {
  dispatch(pickupLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const newPickupDays = days.map((day) => ({
    day: day,
    endTime: timeObj?.endTime,
    startTime: timeObj?.startTime
  }));
  try {
    await userRef.set(
      {
        pickupDays: newPickupDays
      },
      { merge: true }
    );
    dispatch({ type: "ADD_PICKUP_DAYS", payload: newPickupDays });
    dispatch(pickupLoader(false));
    toast.success("PickUp Days Updates Successfully");
  } catch (err) {
    toast.error(err.message);
    dispatch(pickupLoader(false));
  }
};

export const addDeliveryDays = (id, days, timeObj) => async (dispatch) => {
  dispatch(deliveryLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const newDeliveryDays = days.map((day) => ({
    day: day,
    endTime: timeObj?.endTime,
    startTime: timeObj?.startTime
  }));
  try {
    await userRef.set(
      {
        deliveryDays: newDeliveryDays
      },
      { merge: true }
    );
    dispatch({ type: "ADD_DELIVERY_DAYS", payload: newDeliveryDays });
    dispatch(deliveryLoader(false));
    toast.success("Delivery Days Added Successfully");
  } catch (err) {
    toast.error(err.message);
    dispatch(deliveryLoader(false));
  }
};

export const updateDeliveryDays = (id, days, timeObj) => async (dispatch) => {
  dispatch(deliveryLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  const newDeliveryDays = days.map((day) => ({
    day: day,
    endTime: timeObj?.endTime,
    startTime: timeObj?.startTime
  }));
  try {
    await userRef.set(
      {
        deliveryDays: newDeliveryDays
      },
      { merge: true }
    );
    dispatch({ type: "ADD_DELIVERY_DAYS", payload: newDeliveryDays });
    dispatch(deliveryLoader(false));
    toast.success("Delivery Days Updated Successfully");
  } catch (err) {
    toast.error(err.message);
    dispatch(deliveryLoader(false));
  }
};

export const updateRestaurantProfile = (id, obj) => async (dispatch) => {
  dispatch(profileLoader(true));
  const userRef = firebase.firestore().collection("users").doc(id);
  await userRef
    .get()
    .then((doc) => {
      const updatedData = {
        ...doc.data(),
        ...obj
      };
      return userRef.update(updatedData);
    })
    .then(() => {
      dispatch({
        type: "SET_USER",
        payload: { ...obj }
      });
      dispatch(profileLoader(false));
      toast.success("Update Profile Successfully");
    })
    .catch((err) => {
      dispatch(profileLoader(false));
      toast.error(err.message);
    });
};

export const updateLanguages =
  (id, languages, onSuccess) => async (dispatch) => {
    dispatch(profileLoader(true));
    const db = firebase.firestore();
    const docRef = db.collection("users").doc(id);
    docRef
      .update({ languages: languages }, { merge: true })
      .then(async () => {
        dispatch(profileLoader(false));
        const docRef = db.collection("users").doc(id);
        const Doc = await docRef.get();
        dispatch({
          type: "UPDATE_RESTAURANT_LANGUAGE",
          payload: { languages: Doc.data().languages }
        });
        toast.success("Languages Update Successfully");

        onSuccess();
      })
      .catch((err) => {
        dispatch(profileLoader(false));
        toast.error(err.message);
      });
  };

export const updateRestaurantCurrency = (id, currency) => async (dispatch) => {
  dispatch(currencyLoader(true));
  const db = firebase.firestore();
  const docRef = db.collection("users").doc(id);
  docRef
    .update({ currency: currency }, { merge: true })
    .then(() => {
      dispatch(currencyLoader(false));
      toast.success("Currency Update Successfully");
    })
    .catch((err) => {
      dispatch(currencyLoader(false));
      toast.error(err.message);
    });
};

export const updateProfilePicture = (item) => async (dispatch) => {
  dispatch(profileLoader(true));

  try {
    const docRef = await firebase
      .firestore()
      .collection("users")
      .where("restaurantID", "==", item.id)
      .where("type", "==", "restaurant")
      .get();

    if (!docRef.empty) {
      const docData = docRef.docs[0].data();
      const docId = docRef.docs[0].id;
      if (docData?.restaurantLogo) {
        try {
          await firebase.storage().refFromURL(docData.restaurantLogo).delete();
        } catch (err) {
          console.warn("Error deleting previous logo:", err.message);
        }
      }
      const fileName = item.img.name;
      const fileExt = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
      const newFileName = `${item.id}${fileExt}`;

      const storageRef = firebase
        .storage()
        .ref("restaurant_logo/")
        .child(newFileName);

      await storageRef.put(item.img);
      const newLogoURL = await storageRef.getDownloadURL();

      await firebase.firestore().collection("users").doc(docId).update({
        restaurantLogo: newLogoURL
      });

      dispatch(profileLoader(false));
      toast.success("Logo updated successfully!");
    } else {
      dispatch(profileLoader(false));
      toast.error("Restaurant document not found!");
    }
  } catch (err) {
    console.error("Error:", err.message || err);
    dispatch(profileLoader(false));
    toast.error("Failed to update logo.");
  }
};

let email = RepositoryFactory.get("email");
export const updateEmail = (payload) => async (dispatch) => {
  dispatch(profileLoader(true));
  try {
    const { data } = await email.updateEmail(payload);
    if (data.success) {
      toast.success(data.message);
      dispatch(profileLoader(false));
    } else {
      toast.error(data.message);
      dispatch(profileLoader(false));
    }
  } catch (error) {
    toast.error(error.message);

    dispatch(profileLoader(false));
  }
};

const imageLoader = (data) => async (dispatch) => {
  dispatch({
    type: "IMAGE_LOADER",
    payload: data
  });
};

const bannerDeleteLoader = (data) => async (dispatch) => {
  dispatch({
    type: "REMOVE_BANNER_LOADER",
    payload: data
  });
};

const storeLoader = (data) => async (dispatch) => {
  dispatch({
    type: "STORE_TIMING_LOADER",
    payload: data
  });
};

const Loader = (data) => async (dispatch) => {
  dispatch({
    type: "CATALOG_LOADER",
    payload: data
  });
};

const addLoader = (data) => async (dispatch) => {
  dispatch({
    type: "ADD_LOADER",
    payload: data
  });
};

const addHolidayLoading = (data) => async (dispatch) => {
  dispatch({
    type: "ADD_HOLIDAY_LOADER",
    payload: data
  });
};

const removePaymentLoader = (data) => async (dispatch) => {
  dispatch({
    type: "REMOVE_PAYMENT_LOADER",
    payload: data
  });
};

const deleteHolidayLoading = (data) => async (dispatch) => {
  dispatch({
    type: "DELETE_HOLIDAY_LOADER",
    payload: data
  });
};

const removeLoader = (data) => async (dispatch) => {
  dispatch({
    type: "REMOVE_LOADER",
    payload: data
  });
};

const tipLoader = (data) => async (dispatch) => {
  dispatch({
    type: "TIP_LOADER",
    payload: data
  });
};

const chargesLoader = (data) => async (dispatch) => {
  dispatch({
    type: "CHARGES_LOADER",
    payload: data
  });
};

const chargesDeleteLoader = (data) => async (dispatch) => {
  dispatch({
    type: "CHARGES_DELETE_LOADER",
    payload: data
  });
};

const pickupLoader = (data) => async (dispatch) => {
  dispatch({
    type: "PICKUP_LOADER",
    payload: data
  });
};

const deliveryLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DELIVERY_LOADER",
    payload: data
  });
};
const paymentConnectionLoader = (data) => async (dispatch) => {
  dispatch({
    type: "PAYMENT_CONNECTION_LOADER",
    payload: data
  });
};

const getForwardFeesLoader = (data) => async (dispatch) => {
  dispatch({
    type: "GET_FORWARD_FEES_LOADER",
    payload: data
  });
};

const addForwardFeesLoader = (data) => async (dispatch) => {
  dispatch({
    type: "ADD_FORWARD_FEES_LOADER",
    payload: data
  });
};

const deleteForwardFeesLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DELETE_FORWARD_FEES_LOADER",
    payload: data
  });
};

const updateForwardFeesLoader = (data) => async (dispatch) => {
  dispatch({
    type: "UPDATE_FORWARD_FEES_LOADER",
    payload: data
  });
};

const profileLoader = (data) => async (dispatch) => {
  dispatch({
    type: "SET_LOADER",
    payload: data
  });
};

const currencyLoader = (data) => async (dispatch) => {
  dispatch({
    type: "SET_CURRENCY_LOADER",
    payload: data
  });
};
